/* sucrase/dist/esm/parser/traverser/util.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.isContextual = isContextual;
    exports.isLookaheadContextual = isLookaheadContextual;
    exports.eatContextual = eatContextual;
    exports.expectContextual = expectContextual;
    exports.canInsertSemicolon = canInsertSemicolon;
    exports.hasPrecedingLineBreak = hasPrecedingLineBreak;
    exports.hasFollowingLineBreak = hasFollowingLineBreak;
    exports.isLineTerminator = isLineTerminator;
    exports.semicolon = semicolon;
    exports.expect = expect;
    exports.unexpected = unexpected;
    const index_1 = require("bfb18d0576") /* ../tokenizer/index */;
    const types_1 = require("f0c35cbd76") /* ../tokenizer/types */;
    const charcodes_1 = require("22746c8ce8") /* ../util/charcodes */;
    const base_1 = require("540718e523") /* ./base */;
    // ## Parser utilities
    // Tests whether parsed token is a contextual keyword.
    function isContextual(contextualKeyword) {
        return base_1.state.contextualKeyword === contextualKeyword;
    }
    function isLookaheadContextual(contextualKeyword) {
        const l = (0, index_1.lookaheadTypeAndKeyword)();
        return l.type === types_1.TokenType.name && l.contextualKeyword === contextualKeyword;
    }
    // Consumes contextual keyword if possible.
    function eatContextual(contextualKeyword) {
        return base_1.state.contextualKeyword === contextualKeyword && (0, index_1.eat)(types_1.TokenType.name);
    }
    // Asserts that following token is given contextual keyword.
    function expectContextual(contextualKeyword) {
        if (!eatContextual(contextualKeyword)) {
            unexpected();
        }
    }
    // Test whether a semicolon can be inserted at the current position.
    function canInsertSemicolon() {
        return (0, index_1.match)(types_1.TokenType.eof) || (0, index_1.match)(types_1.TokenType.braceR) || hasPrecedingLineBreak();
    }
    function hasPrecedingLineBreak() {
        const prevToken = base_1.state.tokens[base_1.state.tokens.length - 1];
        const lastTokEnd = prevToken ? prevToken.end : 0;
        for (let i = lastTokEnd; i < base_1.state.start; i++) {
            const code = base_1.input.charCodeAt(i);
            if (code === charcodes_1.charCodes.lineFeed ||
                code === charcodes_1.charCodes.carriageReturn ||
                code === 0x2028 ||
                code === 0x2029) {
                return true;
            }
        }
        return false;
    }
    function hasFollowingLineBreak() {
        const nextStart = (0, index_1.nextTokenStart)();
        for (let i = base_1.state.end; i < nextStart; i++) {
            const code = base_1.input.charCodeAt(i);
            if (code === charcodes_1.charCodes.lineFeed ||
                code === charcodes_1.charCodes.carriageReturn ||
                code === 0x2028 ||
                code === 0x2029) {
                return true;
            }
        }
        return false;
    }
    function isLineTerminator() {
        return (0, index_1.eat)(types_1.TokenType.semi) || canInsertSemicolon();
    }
    // Consume a semicolon, or, failing that, see if we are allowed to
    // pretend that there is a semicolon at this position.
    function semicolon() {
        if (!isLineTerminator()) {
            unexpected('Unexpected token, expected ";"');
        }
    }
    // Expect a token of a given type. If found, consume it, otherwise,
    // raise an unexpected token error at given pos.
    function expect(type) {
        const matched = (0, index_1.eat)(type);
        if (!matched) {
            unexpected(`Unexpected token, expected "${(0, types_1.formatTokenType)(type)}"`);
        }
    }
    /**
     * Transition the parser to an error state. All code needs to be written to naturally unwind in this
     * state, which allows us to backtrack without exceptions and without error plumbing everywhere.
     */
    function unexpected(message = "Unexpected token", pos = base_1.state.start) {
        if (base_1.state.error) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const err = new SyntaxError(message);
        err.pos = pos;
        base_1.state.error = err;
        base_1.state.pos = base_1.input.length;
        (0, index_1.finishToken)(types_1.TokenType.eof);
    }
}
